<template>
  <div class="con2">
    <div class="container">
      <div class="content">
        <div class="text-content">
          <p class="text0">완벽 진단! 완벽 개선!</p>
          <p class="text1">
            말랑톡만의<br class="br-m" />
            맞춤 학습 피드백
          </p>
          <p class="text2">
            진단을 통한 개선 및 동기 부여로<br /><span
              >실전경험의 학습전이!</span
            >
          </p>
        </div>
        <div class="img-content">
          <div class="left">
            <div>
              <p class="m-text0">AI 맞춤 피드백</p>
              <p class="m-text1">
                실전 대화 후, 바로 제공되는<br /><span
                  >발화분석 피드백으로<br />즉각적인 교정과 동기 부여
                  제공!</span
                >
              </p>
              <video
                muted
                autoplay
                playsinline
                loop
                poster="@/assets/img/aitutorplus/con2/video1-poster-pc.png"
                src="@/assets/img/aitutorplus/con2/video1-pc.mp4"
                class="video-pc"
              ></video>
              <video
                muted
                autoplay
                playsinline
                loop
                poster="@/assets/img/aitutorplus/con2/video1-poster-m.png"
                src="@/assets/img/aitutorplus/con2/video1-m.mp4"
                class="video-m"
              ></video>
            </div>
            <p class="pc-text0">AI 맞춤 피드백</p>
            <p class="pc-text1">
              실전 대화 후, 바로 제공되는
              <span
                >발화분석 피드백으로<br />즉각적인 교정과 동기 부여 제공!</span
              >
            </p>
          </div>
          <div class="right">
            <div>
              <p class="m-text0">AI 학습 분석 리포트</p>
              <p class="m-text1">
                <span
                  >매월 나의 영어 말하기 수준과<br />사용 언어에 대한 정량적
                  분석</span
                >으로<br />학습자의 지속적인 실력 향상 지원!
              </p>
              <video
                muted
                autoplay
                playsinline
                loop
                poster="@/assets/img/aitutorplus/con2/video2-poster-pc.png"
                src="@/assets/img/aitutorplus/con2/video2-pc.mp4"
                class="video-pc"
              ></video>
              <video
                muted
                autoplay
                playsinline
                loop
                poster="@/assets/img/aitutorplus/con2/video2-poster-m.png"
                src="@/assets/img/aitutorplus/con2/video2-m.mp4"
                class="video-m"
              ></video>
            </div>
            <p class="pc-text0">AI 학습 분석 리포트</p>
            <p class="pc-text1">
              <span
                >매월 나의 영어 말하기 수준과 사용 언어에 대한<br />정량적
                분석</span
              >으로 학습자의 지속적인 실력 향상 지원!
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

video {
  display: block;
  width: 100%;
  height: 360px;
  object-fit: cover;

  @media screen and (min-width: 1200px) {
    height: auto;
  }

  &.video-m {
    @media screen and (min-width: 1200px) {
      display: none;
    }
  }

  &.video-pc {
    display: none;
    @media screen and (min-width: 1200px) {
      display: block;
    }
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con2 {
  padding: 86px 0;
  background-color: #18181b;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 50px;

    @media screen and (min-width: 1200px) {
      gap: 82px;
    }

    .text-content {
      text-align: center;

      .text0 {
        font-size: 20px;
        font-weight: 700;
        color: #8b5cf6;
        margin-bottom: 14px;

        @media screen and (min-width: 1200px) {
          font-size: 52px;
          margin-bottom: 0;
        }
      }

      .text1 {
        font-size: 30px;
        font-weight: 700;
        color: #fff;
        margin-bottom: 24px;

        @media screen and (min-width: 1200px) {
          font-size: 52px;
          margin-bottom: 50px;
        }
      }

      .text2 {
        font-size: 18px;
        color: #fff;
        line-height: 27px;

        span {
          font-weight: 700;
        }

        @media screen and (min-width: 1200px) {
          font-size: 32px;
          line-height: 48px;
        }
      }
    }

    .img-content {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 28px;
      width: 320px;
      margin: 0 auto;

      @media screen and (min-width: 1200px) {
        flex-direction: row;
        gap: 36px;
        width: auto;
      }

      &::before {
        content: "";
        width: 62px;
        height: 62px;
        background: url(~@/assets/img/aitutorplus/con2/plus.png) no-repeat
          center / contain;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        @media screen and (min-width: 1200px) {
          width: 82px;
          height: 82px;
          top: 220px;
          transform: translate(-50%, 0);
        }
      }

      .left {
        @media screen and (min-width: 1200px) {
          flex-grow: 1;
          width: 100%;
        }

        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 42px;
          border: 1px solid #8b95a1;
          border-radius: 26px;
          overflow: hidden;

          @media screen and (min-width: 1200px) {
            padding: 0;
            margin-bottom: 48px;
          }

          .m-text0 {
            font-size: 26px;
            font-weight: 700;
            color: #8b5cf6;
            margin-bottom: 12px;

            @media screen and (min-width: 1200px) {
              display: none;
            }
          }

          .m-text1 {
            font-size: 18px;
            color: #8b95a1;
            text-align: center;
            line-height: 26px;

            span {
              font-weight: 700;
            }

            @media screen and (min-width: 1200px) {
              display: none;
            }
          }

          img {
            width: 320px;

            @media screen and (min-width: 1200px) {
              width: 582px;
            }
          }
        }

        .pc-text0 {
          display: none;

          @media screen and (min-width: 1200px) {
            display: block;
            font-size: 30px;
            font-weight: 700;
            color: #8b5cf6;
            text-align: center;
            margin-bottom: 16px;
          }
        }

        .pc-text1 {
          display: none;

          @media screen and (min-width: 1200px) {
            display: block;
            font-size: 18px;
            color: #8b95a1;
            text-align: center;
            line-height: 28px;

            span {
              font-weight: 700;
            }
          }
        }
      }

      .right {
        @media screen and (min-width: 1200px) {
          flex-grow: 1;
          width: 100%;
        }

        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 42px;
          background-color: #e5e7eb;
          border-radius: 26px;
          overflow: hidden;

          @media screen and (min-width: 1200px) {
            padding: 0;
            margin-bottom: 48px;
          }

          .m-text0 {
            font-size: 26px;
            font-weight: 700;
            color: #8b5cf6;
            margin-bottom: 12px;

            @media screen and (min-width: 1200px) {
              display: none;
            }
          }

          .m-text1 {
            font-size: 18px;
            color: #374151;
            text-align: center;
            line-height: 26px;

            span {
              font-weight: 700;
            }

            @media screen and (min-width: 1200px) {
              display: none;
            }
          }

          img {
            width: 320px;

            @media screen and (min-width: 1200px) {
              width: 582px;
            }
          }
        }

        .pc-text0 {
          display: none;

          @media screen and (min-width: 1200px) {
            display: block;
            font-size: 30px;
            font-weight: 700;
            color: #8b5cf6;
            text-align: center;
            margin-bottom: 16px;
          }
        }

        .pc-text1 {
          display: none;

          @media screen and (min-width: 1200px) {
            display: block;
            font-size: 18px;
            color: #8b95a1;
            text-align: center;
            line-height: 28px;

            span {
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
</style>
